// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { ZIndex } from "@msnews/core";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { getEmojiStylesByWidth } from "../../utils/emojiIcons";

export const ReactionMenuStyles = (config: DesignSystem) => ({
    reactionMenuContainer: {
        display: "flex !important",
        "align-items": "flex-start",
        "justify-content": "center",
        padding: "6px 13px 0",
        position: "absolute",
        height: "42px",
        background: neutralLayerCard,
        "border-radius": "32px",
        "-webkit-box-shadow": "0px 3.2px 7.2px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px rgba(0, 0, 0, 0.1)",
        "-moz-box-shadow": "0px 3.2px 7.2px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px rgba(0, 0, 0, 0.1)",
        "box-shadow": "0px 3.2px 7.2px rgba(0, 0, 0, 0.13), 0px 0.6px 1.8px rgba(0, 0, 0, 0.1)",
        animation: "reaction-menu-fade-in .2s ease-out",
        "-webkit-animation-fill-mode": "forwards",

        "& div.emoji-icon": {
            ...getEmojiStylesByWidth(16),
            transition: "none"
        },

        "& > .cwt-icon": {
            position: "relative",
            display: "flex",
            "flex-direction": "column",
            margin: "0 0 !important",
            padding: "4px !important",
            "font-size": "18px",

            "& div.emoji-icon": {
                ...getEmojiStylesByWidth(28),
                transition: "ease-out .15s",
                width: "28px"
            },

            "&:hover div.emoji-icon, &:focus div.emoji-icon, &.touchFocused div.emoji-icon": {
                transform: "scale(1.285) translateY(-4px)"
            },

            "&:hover:before, &:focus:before, &.touchFocused:before": {
                position: "absolute",
                "z-index": ZIndex.Dialog.toString(),
                top: "-28px",
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
                content: "attr(data-title)",
                "white-space": "nowrap",
                height: "18px",
                padding: "0 8px 1px",
                "font-size": "13px",
                "text-transform": "capitalize",
                background: neutralForegroundRest,
                color: neutralLayerCard,
                "border-radius": "11px"
            }
        }
    },

    reactionMenuPopover: {
        top: "-46px",
        [applyLocalizedProperty("left", "right", config.direction)]: "-10px",
        "padding-bottom": "4px"
    },

    "@keyframes reaction-menu-fade-in": {
        from: { top: "-6px", opacity: "0" },
        to: { top: "-13px", opacity: "1" }
    }
});